import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { withGuestPage } from 'hoc'

import BasePage from 'modules/marketplace/layout/components/BasePage'
import SignupUserForm from 'modules/signup/components/SignupUserForm'
import SignupUserContainer from 'modules/signup/components/SignupUserContainer'
import MarketingSignupHero from 'modules/signup/components/MarketingSignupHero'
import AuthContainer from 'modules/auth/components/AuthContainer'
import { UserSignupSourceEnum } from '../../../../../__generated__/globalTypes'

const SignupRepPage = () => {
  const router = useRouter()

  return (
    <BasePage hasHeader={false} hasFooter={false}>
      <Head>
        <title>Sales Rep Signup · Fieldfolio</title>
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/signup/sales-rep`} />
        <meta name="robots" content="nofollow, noindex, noarchive" />
      </Head>

      <SignupUserContainer
        leftContent={
          <MarketingSignupHero
            imageUrl="/marketing/signup/rep.jpg"
            heading="Sell wholesale in the field on iPad"
            subheading="Simply create your Fieldfolio Sales Rep profile and choose from over one thousand Sellers to connect with!"
          />
        }
        rightContent={
          <AuthContainer
            heading="Sales Rep Signup"
            progressPercent={25}
            centered
            caption={<>A Sales Rep account is for independent sales agents who sell on behalf of wholesalers.</>}>
            <SignupUserForm signupSource={UserSignupSourceEnum.REP} onSignupSuccess={() => router.push('/verify')} />
          </AuthContainer>
        }
      />
    </BasePage>
  )
}

export default withGuestPage()(SignupRepPage)
